module.exports = __webpack_public_path__ + "static/img/welcome_pop.b894157.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/welcome_pop.webp
// module id = BlQZ
// module chunks = 0